import service from "@/utils/request";
//学员列表
export interface studentListData {
  page: number;
  page_size: number;
  key_word?: string;
  class_id?: number;
  teacher_id?: number;
  follow_staff_id?: number;
  sex?: number;
}
// 添加学员
export interface addStudentData {
  name: string;
  mobile: string;
  avatar?: string;
  mobile_relation?: number;
  sex?: number;
  birthday?: number;
  age?: number;
  guardian_relation?: number;
  guardian_mobile?: string;
  home_address?: string;
  school?: string;
  remark?: string;
  source_type: number;
  teacher_id?: number;
  follow_staff_id?: number;
  status: number;
  subject_ids?: number[];
  force?: number;
  area_code: string;
  guardian_area_code?: string;
  face_image?: string;
  market_staff_id?: number;
}
// 搜索列表
export interface autoSearchData {
  page: number;
  page_size: number;
  key_word?: String;
  name?: String;
}
// 学员列表
export const studentList = (data: studentListData) => {
  return service({
    url: "/api/v1/student/list",
    method: "post",
    data,
  });
};
// 添加学员--头像接口
export const addStudentHeader = () => {
  return service({
    url: "/api/v1/student/avatar_list",
    method: "get",
  });
};
// 添加学员--关系接口
export const addMobileRelation = () => {
  return service({
    url: "/api/v1/student/mobile_relation",
    method: "get",
  });
};
// 添加学员--监护人接口
export const addStudentGuardian = () => {
  return service({
    url: "/api/v1/student/guardian_relation",
    method: "get",
  });
};
interface SourceTypeInter {
  include_del?: number;
}
// 添加学员--性别
export const addsex = () => {
  return service({
    url: "/api/v1/student/sex",
    method: "get",
  });
};

// 学员增加
export const addStudent = (data: addStudentData) => {
  return service({
    url: "/api/v1/student/add",
    method: "post",
    data: data,
  });
};

// 教师搜索列表
export const geteacherList = (params: autoSearchData) => {
  return service({
    url: "/api/v1/teacher/list",
    method: "get",
    params,
  });
};
// 班级搜索列表
export const getSelectClassList = (params: autoSearchData) => {
  return service({
    url: "/api/v1/class/select_list",
    method: "get",
    params,
  });
};
//导出列表
export interface exportStudentData {
  key_word?: string;
  class_id?: number;
  teacher_id?: number;
  follow_staff_id?: number;
  sex?: number;
  class_teacher_id?: number;
  intent_arr?: number[];
  start_time?: string;
  end_time?: string;
}
//导出
export const exportStudent = (data: exportStudentData) => {
  return service({
    url: "/api/v1/student/list/export",
    method: "post",
    data,
  });
};

// 操作学员积分
export interface changeStudentIntegralData {
  student_id: number;
  integral: number;
  type: number;
  remark: string;
}
export const changeStudentIntegralApi = (data: changeStudentIntegralData) => {
  return service({
    url: "/api/v1/integral/student/change",
    method: "post",
    data,
  });
};

// 意向学员列表
export interface getLatentStudentListData {
  page?: number;
  page_size?: number;
  key_word?: string;
  sex?: number;
  follow_staff_id?: number;
  source_type?: number;
  appear_id?: number;
  subject_id?: number;
  stage?: number;
  intent?: number;
  follow_status?: number;
  start_time?: number;
  end_time?: number;
  create_staff_id?: number;
  intent_arr?: [];
  sort_type?: string;
  sort_field?: string;
  age_stage?: number;
  acquisition_start_time?: string;
  acquisition_end_time?: string;
  recruit_staff?: string;
  market_staff_id?: number;
  market_activity_id?: number;
  remark?: string;
  allocate_num_start?: number;
  allocate_num_end?: number;
  follow_start_time?: string;
  follow_end_time?: string;
  follow_staff_filtering?: string;
  quick_filtering?: string;
}
export const getLatentStudentListApi = (data: getLatentStudentListData) => {
  return service({
    url: "/api/v1/student/latent/list",
    method: "post",
    data,
  });
};

// 批量分配意向学员(弃用)
export interface mutiEditFollowStaffData {
  student_ids: number[];
  follow_staff_id: number;
}
export const mutiEditFollowStaffApi = (data: mutiEditFollowStaffData) => {
  return service({
    url: "/api/v1/student/distribute",
    method: "post",
    data,
  });
};

// 获取意向学员Excel
export const getLatentExcelApi = () => {
  return service({
    url: "/api/v1/student/latent/excel",
    method: "get",
  });
};

// 回收学员列表
export interface getRecycleStudentListData {
  page?: number;
  page_size?: number;
  key_word?: string;
  recycle_staff_id?: number;
  recycle_start_time?: number;
  recycle_end_time?: number;
  start_time?: number;
  end_time?: number;
  age_stage?: number;
  recycle_category_id?: number;
  appear_id?: number;
  source_type?: number;
  allocate_num_start?: number;
  allocate_num_end?: number;
  follow_start_time?: string;
  follow_end_time?: string;
  sort_type?: string;
  sort_field?: string;
}
export const getRecycleStudentListApi = (params: getRecycleStudentListData) => {
  return service({
    url: "/api/v1/student/recycle/list",
    method: "get",
    params,
  });
};

// 回收学员
export interface recycleStudentData {
  student_id: number;
  recycle_remark: string;
}
export const recycleStudentApi = (data: recycleStudentData) => {
  return service({
    url: "/api/v1/student/recycle",
    method: "post",
    data,
  });
};

// 回收学员还原
export interface recycleStudentrecoverData {
  student_ids: number[];
  join_potential: boolean;
  follow_staff_id?: number;
}
export const recycleStudentrecoverApi = (data: recycleStudentrecoverData) => {
  return service({
    url: "/api/v1/student/recycle/recover",
    method: "post",
    data,
  });
};

// 公海池列表
export interface getWaitingStudentListData {
  page?: number;
  page_size?: number;
  key_word?: string;
  sex?: number;
  follow_staff_id?: number;
  appear_id?: number;
  source_type?: number;
  subject_id?: number;
  stage?: number;
  intent?: number;
  follow_status?: number[];
  start_time?: number;
  end_time?: number;
  create_staff_id?: number;
  intent_arr?: number[];
  age_stage?: number;
  acquisition_start_time?: string;
  acquisition_end_time?: string;
  recruit_staff?: string;
  market_staff_id?: number;
  market_activity_id?: number;
  remark?: string;
  allocate_num_start?: string;
  allocate_num_end?: string;
  follow_start_time?: string;
  follow_end_time?: string;
  allocate_start_time?: string;
  allocate_end_time?: string;
  last_follow_staff_id?: number;
  sort_type?: string;
  sort_field?: string;
}
export const getWaitingStudentListApi = (params: getWaitingStudentListData) => {
  return service({
    url: "/api/v1/student/latent/not_assign_list",
    method: "get",
    params,
  });
};
// 公海池导出
export const exportWaitingStudentListApi = (
  params: getWaitingStudentListData
) => {
  return service({
    url: "/api/v1/student/latent/potential_list_export",
    method: "get",
    params,
  });
};
// 批量认领
export const claimWaitingStudentApi = (data: { student_ids: number[] }) => {
  return service({
    url: "/api/v1/student/latent/batch_claim",
    method: "post",
    data,
  });
};

//历史学员列表
export interface historyListData {
  page: number;
  page_size: number;
  key_word?: string;
  sex?: number;
  follow_staff_id?: number;
  completion_start_time?: string;
  completion_end_time?: string;
  sort_field?: string;
  sort_type?: string;
  transform_start_time?: string;
  transform_end_time?: string;
  intent_arr?: number[];
  age_start?: number;
  age_end?: number;
  age_stage?: number;
  completion_category_id?: number;
  latest_transform_start_time?: string;
  latest_transform_end_time?: string;
}
export const historyList = (data: historyListData) => {
  return service({
    url: "/api/v1/student/history/list",
    method: "post",
    data,
  });
};
//导出
export const historyExport = (data: historyListData) => {
  return service({
    url: "/api/v1/student/history/export",
    method: "post",
    data,
  });
};

// 意向学员导出
export const latentListExport = (data: getLatentStudentListData) => {
  return service({
    url: "/api/v1/student/latent/list_export",
    method: "post",
    data,
  });
};

// 结课记录列表
export interface completionListInter {
  page: number;
  page_size: number;
  sort_field?: string;
  sort_type?: string;
  key_word?: string;
  follow_staff_id?: number;
  edu_teacher_id?: number;
  teacher_id?: number;
  subject_id?: number;
  course_id?: number;
  course_type?: number;
  status?: number;
  completion_start_time?: string;
  completion_end_time?: string;
}
export const completionListApi = (params: completionListInter) => {
  return service({
    url: "/api/v1/student/course/completion_list",
    method: "get",
    params,
  });
};
export const studentAppearApi = () => {
  return service({
    url: "/api/v1/student/appear",
    method: "get",
  });
};
// 历史转意向
export const studentHistoryToIntentApi = (data: { student_id: number }) => {
  return service({
    url: "/api/v1/student/history/to_intent",
    method: "post",
    data,
  });
};
// 学员来源 KV 列表（弃用）
export const sourceTypeKVListApi = (params?: { appear_id: number }) => {
  return service({
    url: "/api/v1/student/source_type",
    method: "get",
    params,
  });
};
// 放弃意向学员
export const cancelFollowStudentApi = (data: { student_id: number }) => {
  return service({
    url: "/api/v1/student/latent/give_up",
    method: "post",
    data,
  });
};
// 学员生日列表
export const studentBirthdayListApi = (params: any) => {
  return service({
    url: "/api/v1/student/birthday_list",
    method: "get",
    params,
  });
};
// 学员生日列表导出
export const studentBirthdayListExportApi = (params: any) => {
  return service({
    url: "/api/v1/student/birthday_list_export",
    method: "get",
    params,
  });
};
